import { cn } from "@/shared/lib/utils"
import { Badge } from "@/shared/ui/badge"
import type { CustomBotStatus } from "../api/types"

const STATUS: Record<CustomBotStatus, { label: string; className: string }> = {
	ACTIVE: {
		label: "Работает",
		className: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
	},
	ERROR: { label: "Ошибка", className: "bg-destructive/15 text-red-400 border-destructive/40" },
	DISABLED: { label: "Выключен", className: "bg-muted text-muted-foreground border-border" },
}

export function BotStatusBadge({ status }: { status: CustomBotStatus }) {
	const { label, className } = STATUS[status]
	return (
		<Badge variant="outline" className={cn(className)}>
			{label}
		</Badge>
	)
}
